import { CosmosClient } from "@azure/cosmos";
import { authProvider } from '../utils/authProvider';

export class UserUtil {
        
    public async ResetPassword(_kv: any) {
        let accountInfo = await authProvider.getAccountInfo();

        // {
        //     "userOId":"oId",
        //     "password":"newPassword"
        // }

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/UserResetPassword?code=RW05BTHsjtiugN61InT3malemE/wQiaaRWpzjcWHC7HIypZpfNXjUw==';

        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_kv)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Newly created document
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    // public async GetList(searchParams: any) {
    //     let accountInfo = await authProvider.getAccountInfo();

    //     let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
    //     let API_ENDPOINT = '/UserColGetList?code=MRi4zYa2oGF9Apa61m8YDjYAypBSM0e0BZyoDjItIrS2jkq1tzHs6g==';
    //     let API = API_URL + API_ENDPOINT ;

    //     let response = await fetch(API,
    //         {
    //             method: "post",
    //             headers: new Headers({
    //                 "Authorization": "Bearer " + accountInfo?.jwtIdToken,
    //                 "Content-Type": "application/json"
    //             }),
    //             body: JSON.stringify(searchParams)
    //         }
    //     );
    //     if (response.ok) {
    //         let result = await response.json();
    //         if (result.isSuccess) {
    //             return result;
    //         } else {
    //             return { errors : result.errors };
    //         }
    //     } else {
    //         // Error return from Azure Fucntion
    //         let errorResponse = await response.json();
    //         return { errors : 'Connection failed to API. Error:' + errorResponse.Message };
    //     }
    // }

    // public async Read(_id: string, _year: number) {
    //     let accountInfo = await authProvider.getAccountInfo();

    //     let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
    //     let API_ENDPOINT = '/UserColRead?code=X3te8oGhgocCr/Wmx2ax4UJj/MAS5RGDV8BbjaSW3ANq43V8gZHzyQ==';
    //     let API_PARAM = '&id=' + _id + '&period=' + _year;
    //     let API = API_URL + API_ENDPOINT + API_PARAM;

    //     let response = await fetch(API,
    //         {
    //             method: "get",
    //             headers: new Headers({
    //                 "Authorization": "Bearer " + accountInfo?.jwtIdToken,
    //                 "Content-Type": "application/json"
    //             })
    //         }
    //     );
    //     if (response.ok) {
    //         let result = await response.json();
    //         if (result.isSuccess) {
    //             return result;
    //         } else {
    //             return { errors : result.errors };
    //         }
    //     } else {
    //         return { errors : 'Connection failed to API' };
    //     }
    // }

    // public async Create(_doc: any) {
    //     let accountInfo = await authProvider.getAccountInfo();

    //     let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
    //     let API_ENDPOINT = '/UserColCreate?code=NiME00DidVklgbiqrIxSq6H/9R3R/RovFzgZfatrylOsneRleovTwA==';

    //     let API = API_URL + API_ENDPOINT;
    //     let response = await fetch(API,
    //         {
    //             method: "post",
    //             headers: new Headers({
    //                 "Authorization": "Bearer " + accountInfo?.jwtIdToken,
    //                 "Content-Type": "application/json"
    //             }),
    //             body: JSON.stringify(_doc)
    //         }
    //     );

    //     if (response.ok) {
    //         let result = await response.json();
    //         if (result.isSuccess) {
    //             return result; // Newly created document
    //         } else {
    //             return { errors : result.errors };
    //         }
    //     } else {
    //         // Error return from Azure Fucntion
    //         let errorResponse = await response.json();
    //         return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
    //     }
    // }

    // public async Update(_keyValues: any) {
    //     let accountInfo = await authProvider.getAccountInfo();

    //     let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
    //     let API_ENDPOINT = '/UserColSet?code=uwPn0YWp6gukJE8Rfn4kup4Zk5tCn/6rSL2FjKI5nNNGayBLcxV0MQ==';
    //     let API = API_URL + API_ENDPOINT;
    //     let response = await fetch(API,
    //         {
    //             method: "post",
    //             headers: new Headers({
    //                 "Authorization": "Bearer " + accountInfo?.jwtIdToken,
    //                 "Content-Type": "application/json"
    //             }),
    //             body: JSON.stringify(_keyValues)
    //         }
    //     );

    //     if (response.ok) {
    //         let result = await response.json();
    //         if (result.isSuccess) {
    //             return result; // Updated document
    //         } else {
    //             return { errors : result.errors, isConflict : result.isConflict };
    //         }
    //     } else {
    //         // Error return from Azure Fucntion
    //         let errorResponse = await response.json();
    //         return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
    //     }
    // }

    // public async Delete(_id: string, _year: number) {
    //     let accountInfo = await authProvider.getAccountInfo();
        
    //     let _doc : any = {};
    //     _doc.id = _id;
    //     _doc.period = _year;

    //     let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
    //     let API_ENDPOINT = '/UserColDelete?code=CgBsRd0hWFIyI/3lRUEaxRXRQdCtgLjhmgpV6ONNoMfXdbhv2sAxew==';
    //     let API = API_URL + API_ENDPOINT;
    //     let response = await fetch(API,
    //         {
    //             method: "post",
    //             headers: new Headers({
    //                 "Authorization": "Bearer " + accountInfo?.jwtIdToken,
    //                 "Content-Type": "application/json"
    //             }),
    //             body: JSON.stringify(_doc)
    //         }
    //     );

    //     if (response.ok) {
    //         let result = await response.json();
    //         if (result.isSuccess) {
    //             return result; // Updated document
    //         } else {
    //             return { errors : result.errors };
    //         }
    //     } else {
    //         // Error return from Azure Fucntion
    //         let errorResponse = await response.json();
    //         return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
    //     }
    // }


}